'use client';

import { lazy, useState } from 'react';

import { MagicAi } from '@ui/uikit/components/icons/poly/MagicAi';

const ChatDialog = lazy(() => import('./ChatDialog/ChatDialog'));

interface AiAgentProps {
  portalMode?: 'none' | 'default' | 'overlay';
}

export const AiAgent = ({ portalMode = 'default' }: AiAgentProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {!isOpen && (
        <button
          className="msq-btn-magic-ai"
          onClick={() => setIsOpen(true)}
          style={{
            //  This is a hack to ensure that AI Agent button is placed correctly on all
            //  pages regardless of whether they support overlays. It can be removed once all pages
            //  support overlays.
            zIndex: portalMode === 'overlay' ? 0 : undefined,
          }}
          aria-label="Ask Mystic AI"
        >
          <MagicAi className="icon-[24px]" />
          <span className="text-caption-sm-strong-a">Ask Mystic AI</span>
        </button>
      )}

      {isOpen && <ChatDialog portalMode={portalMode} onOpenChange={setIsOpen} open={isOpen} />}
    </>
  );
};
